export default function TruncateElement() {}

TruncateElement.initialize = function () {
  /*
    UI example:
      link (text more link below):
       (tag 1)
          more

      angle (inline more up/down angle):
        tag 1 v

      pill (more up/down angle inside pill):
        (tag 1)
        (more v)
  */

  var LINKS = {
    more: '<a href="#" class="read-more toggle-link text-xs mx-auto" aria-expanded="false">More</a>',
    less: '<a href="#" class="read-less toggle-link text-xs mx-auto" aria-expanded="true">Less</a>',
    angle_down: '<a href="#" class="read-more toggle-link text-xs" aria-expanded="false"><i class="fa-solid fa-angle-down"></i></a>',
    angle_up: '<a href="#" class="read-less toggle-link text-xs" aria-expanded="true"><i class="fa-solid fa-angle-up"></i></a>',
    pill_more_down: '<a href="#" class="read-more toggle-link text-xs tw-tag secondary space-x-1 mx-auto" aria-expanded="false"><span>More</span><i class="fa-solid fa-angle-down"></i></a>',
    pill_less_up: '<a href="#" class="read-less toggle-link text-xs tw-tag secondary space-x-1 mx-auto" aria-expanded="true"><span>Less</span><i class="fa-solid fa-angle-up"></i></a>'
  };

  var SELECTORS = {
    visible_data: '#visible-data',
    container: '.container',
    toggle_link: '.toggle-link',
  };

  function truncate(container) {
    container.each(function () {
      var $this = $(this);
      if ($this.data('max-pixels')) {
        collapse_gradient($this);
      } else {
        collapse_row($this);
      }
    });
  }

  function append_toggle_link(truncate_container, link_type) {
    if (truncate_container.hasClass('truncate-angle')) {
      truncate_container.append(LINKS[link_type]);
    } else if (truncate_container.hasClass('truncate-pill')) {
      truncate_container.append(link_type === 'angle_down' ? LINKS.pill_more_down : LINKS.pill_less_up);
    } else {
      truncate_container.append(LINKS[link_type === 'angle_down' ? 'more' : 'less']);
    }
  }

  function collapse_gradient(truncate_container) {
    var max_pixels = truncate_container.data('max-pixels') || '150px';
    var $visible_data = truncate_container.find(SELECTORS.visible_data);
    var $children = truncate_container.children().not(SELECTORS.toggle_link).not('a.left');

    truncate_container.find(SELECTORS.toggle_link).remove();

    if (!$visible_data.length) {
      truncate_container.prepend('<div id="visible-data"></div>');
      $visible_data = truncate_container.find(SELECTORS.visible_data);
    }

    $visible_data.append($children).css('height', max_pixels).removeClass('view-all');
    append_toggle_link(truncate_container, 'angle_down');
  }

  function collapse_row(truncate_container) {
    var maxChildren = truncate_container.data('max-children') || 1;
    var $container = truncate_container.find(SELECTORS.container);

    if (!$container.length) {
      truncate_container.prepend('<div class="container flex space-x-1 w-full"></div>');
      $container = truncate_container.find(SELECTORS.container);
    }

    // For user tags
    if (truncate_container.hasClass('center-stacked')) {
      $container.addClass('flex-col items-center');
    }

    // For the full calendar day
    if (truncate_container.hasClass('stacked')) {
      $container.addClass('flex-col');
    }

    var $children = truncate_container.children().not(SELECTORS.toggle_link).not('a.left');
    $children.appendTo($container);

    var $container_children = $container.children();
    truncate_container.find(SELECTORS.toggle_link).remove();

    if ($container_children.length > maxChildren) {
      $container_children.hide().slice(0, maxChildren).show();
      append_toggle_link(truncate_container, 'angle_down');
    }
  }

  function expand(truncate_container) {
    if (truncate_container.data('max-pixels')) {
      var $visible_data = truncate_container.find(SELECTORS.visible_data);
      $visible_data.css({ height: '100%', background: 'transparent' }).addClass('view-all');
    }

    truncate_container.find(SELECTORS.toggle_link).remove();
    truncate_container.children().not(SELECTORS.toggle_link).not('a.left').children().show();
    append_toggle_link(truncate_container, 'angle_up');
  }

  truncate($('.truncate-container'));

  var check_tab_panel_existence = setInterval(function () {
    $('div[role="tabpanel"]').each(function () {
      var $truncate_containers = $(this).find('.truncate-container');
      if ($truncate_containers.length) {
        truncate($truncate_containers);
        clearInterval(check_tab_panel_existence);
      }
    });
  }, 80);

  setTimeout(function () {
    clearInterval(check_tab_panel_existence);
  }, 10000);

  $(document).on('click', SELECTORS.toggle_link, function (e) {
    e.preventDefault();
    var $this = $(this);
    var $truncate_container = $this.parent();
    var expanded = $this.attr('aria-expanded') === 'false';

    if (expanded) {
      expand($truncate_container);
    } else if ($truncate_container.data('max-pixels')) {
      collapse_gradient($truncate_container);
    } else {
      collapse_row($truncate_container);
    }
  });
};
